import { getRequest } from '../services/requestHandler';
import { HeadTypeLoft } from '../models';

//export const getHeadTypeLofts = async (headTypeId = 0) => {

// get lofts for every head type. Will filter by head type Id in the service
export const getHeadTypeLofts = async () => {
  const url = `head/getHeadTypeLofts`;
  const response = await getRequest<HeadTypeLoft>('GetHeadTypeLofts', url);
  return response;
};
